export default "__VITE_ASSET__M6oH1VvA__"